<div class="container">
    <br>
    <div class="row">
        <div class="col-md-8">
            <div class="d-flex flex-column align-items-start">
                <h1 class="mb-2">{{ foroDetalle?.episode }} {{ foroDetalle?.group }}:</h1>
                <h2 class="mb-3">{{ foroDetalle?.title }}</h2>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-8">
            <div class="row">
                <div class="col-md-12">
                    <div class="image-container">
                        <img src="{{URL}}{{foroDetalle?.img}}" alt="{{foroDetalle?.title }}"
                            class="img-responsive custom-img">
                    </div>
                    <div class="date-ficha d-flex justify-content-between">
                        <small *ngIf="foroDetalle?.year">Fecha publicación: {{ foroDetalle?.year | date: 'd MMMM yyyy' }}</small>
                        <small *ngIf="foroDetalle?.lastUpdated">Fecha actualización: {{ foroDetalle?.lastUpdated | date: 'd MMMM yyyy' }}</small>
                    </div>                                      
                </div>
            </div>
            <div class="text-justify mt-3">
                <p *ngFor="let paragraph of getParagraphs(foroDetalle?.description)">
                    <span [innerHTML]="paragraph"></span>
                </p>
            </div>
        </div>
        <div class="col-md-4 d-flex flex-column justify-content-start align-items-start"
            *ngIf="foroDetalle?.urls?.length>0">
            <div class="embed-responsive embed-responsive-16by9 mb-3" *ngFor="let safeUrl of safeUrls">
                <iframe class="embed-responsive-item" [src]="safeUrl" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="text-left mt-3" *ngIf="foroDetalle.doc && foroDetalle.doc.length > 0">
                <h5>Documentos relacionados:</h5>
                <div *ngFor="let name of foroDetalle.doc_name; let i = index" class="d-flex align-items-center"
                    style="margin-bottom: 10px;">
                    <a href="{{URL}}{{foroDetalle.doc[i]}}" target="_blank"
                        style="color: #3B69AE; text-decoration: none"><i class="fa fa-file-pdf-o"
                            style="color: #F08080 ;"></i> {{name}}.pdf</a>
                </div>
                <br>
            </div>
        </div>
    </div>
</div>